import React from "react";
import { StyleSheet, Text, View } from "react-native";

import LinkIcon from "@/Components/Icons/LinkIcon";
import { themes } from "@/Components/Styling/themeConfigs";
import { type EventOverview } from "@/schemas/events/EventOverview";

type Props = {
  event: EventOverview;
};

function HeroTitleBar({ event }: Props): React.JSX.Element {
  const currentTheme = themes.morning;

  const styles = StyleSheet.create({
    container: {
      position: "absolute",
      bottom: 32,
      left: 0,
      right: 0,
      paddingHorizontal: 32,
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "flex-end",
    },
    titleContainer: {
      flexDirection: "row",
      alignItems: "center",
    },
    title: {
      fontSize: currentTheme.typography.h1.size.web * 1.3,
      color: "#FFFFFF",
      textShadowColor: "rgba(0, 0, 0, 0.75)",
      textShadowOffset: { width: 0, height: 1 },
      textShadowRadius: 4,
    },
    socialContainer: {
      flexDirection: "row",
      gap: 16,
    },
  });

  return (
    <View style={styles.container}>
      <View style={styles.titleContainer}>
        <Text style={styles.title}>{event.title}</Text>
      </View>
      <View style={styles.socialContainer}>
        {event.links.map((link, index) => (
          <LinkIcon key={index} link={link} />
        ))}
      </View>
    </View>
  );
}

export default HeroTitleBar;
